import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Card from "react-bootstrap/Card";
import "./InvoicePage.css";
import { useTheme } from "@emotion/react";
import { FaCloudUploadAlt } from "react-icons/fa"; // FontAwesome Icon


const InvoicePage = ({ handleCreate }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
    const [fileName, setFileName] = useState(""); // Store uploaded file name
    const { palette } = useTheme()
    const [formData, setFormData] = useState({
        invoiceNo: "",
        date: "",
        totalAmount: "",
        latitude: "",
        longitude: "",
        capacity: "",
    });

    const [pdfFile, setPdfFile] = useState(null);
    const [uploadedPdfUrl, setUploadedPdfUrl] = useState("");

    // Handle input change for text fields
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Handle file selection
    const handleFileChange = (e) => {
        setPdfFile(e.target.files[0]);
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            let uploadedFileUrl = uploadedPdfUrl;

            // If a PDF file is selected, upload it
            if (pdfFile) {
                const fileData = new FormData();
                fileData.append("pdfFile", pdfFile);

                const uploadResponse = await fetch("http://localhost:5000/api/uploadPdf", {
                    method: "POST",
                    body: fileData,
                });

                if (!uploadResponse.ok) {
                    throw new Error("Failed to upload PDF");
                }

                const uploadResult = await uploadResponse.json();
                uploadedFileUrl = uploadResult.filePath; // Store uploaded file URL
                setUploadedPdfUrl(uploadedFileUrl);
            }

            // Send form data including PDF URL to the API
            const finalData = { ...formData, pdfUrl: uploadedFileUrl };
            const response = await fetch("/api/createUser", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(finalData),
            });

            if (!response.ok) {
                throw new Error("Failed to create user");
            }

            const newUser = await response.json();
            handleCreate(newUser);
            alert("User created successfully!");

            // Reset form and file input
            setFormData({
                invoiceNo: "",
                date: "",
                totalAmount: "",
                latitude: "",
                longitude: "",
                capacity: "",
            });
            setPdfFile(null);
            setUploadedPdfUrl("");
        } catch (error) {
            console.error("Error:", error);
        }
    };

    // this code for file upload on screen

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (file && file.type === "application/pdf") {
            const url = URL.createObjectURL(file);
            setPdfUrl(url);
            setFileName(file.name)
        } else {
            alert("Please upload a valid PDF file.");
        }
    };

  return (
    <>
      <div className='row'>
        <div className="col-md-12 mt-2">
          <div className="d-flex justify-content-center align-items-center">
            <Card className="custom-card w-100" style={{ border: `2px solid gray` }}>
              {/* <Card.Header
                className="text-white text-center fs-5"
                style={{ backgroundColor: palette.primary.main }}
              >
                Create Performa Invoice
              </Card.Header> */}

              <Card.Body>
                <Form onSubmit={handleSubmit}>  
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="mb-2">
                        <Form.Label>Invoice No.</Form.Label>
                        <Form.Control
                          type="text"
                          name="invoiceNo"
                          value={formData.invoiceNo}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>

                    <div className="col-md-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Date</Form.Label>
                        <Form.Control
                          type="date"
                          name="date"
                          value={formData.date}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>

                    <div className="col-md-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Total Amount</Form.Label>
                        <Form.Control
                          type="text"
                          name="totalAmount"
                          value={formData.totalAmount}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Capacity</Form.Label>
                        <Form.Control
                          type="text"
                          name="capacity"
                          value={formData.capacity}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>

                    <div className="col-md-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Description of Goods</Form.Label>
                        <Form.Control
                          type="text"
                          name="latitude"
                          value={formData.latitude}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="mb-3">
                        <Form.Label>Quantity</Form.Label>
                        <Form.Control
                          type="text"
                          name="longitude"
                          value={formData.longitude}
                          onChange={handleChange}
                          required
                        />
                      </Form.Group>
                    </div>

                    <Form.Group className="mb-3">
                      <Form.Label>Upload PDF</Form.Label>
                      <Form.Control type="file" accept="application/pdf" onChange={handleFileChange} />
                    </Form.Group>
                  </div>


                </Form>
              </Card.Body>

              <Card.Footer>

                <div className="text-center">
                  {/* <Button className="btn text-white" type="submit"  >
                                    Submit
                                </Button> */}
                  <button className="btn text-white" type="submit" style={{ backgroundColor: palette.primary.main }} >  Submit</button>
                </div>

              </Card.Footer>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default InvoicePage;
